(() => {
    if (!customElements.get('video-card')){
        class VideoCard extends HTMLElement {
            constructor() {
                super();
            }
            connectedCallback(){
                this.setHtmlElements();
                this.initVideoCard();
            }
            setHtmlElements(){
                this.cover = this.querySelector('.video-cover');
                this.iframeWrapper = this.querySelector('.video-wrapper');
                this.videoIframe = this.iframeWrapper?.querySelector('iframe');
            }
            initVideoCard(){
                if (this.cover && this.iframeWrapper) {
                    this.cover.addEventListener('click', () => {
                      if (!this.iframeWrapper.classList.contains('active')){
                        this.videoIframe.src = this.videoIframe.getAttribute('data-src');
                        setTimeout(()=> {
                            this.iframeWrapper?.classList.add('active');
                        }, 1000);
                      } 
                    });
                }
            }
        }
        customElements.define('video-card', VideoCard);
    }
})();